import {
    COMMENTS_RESET,
    COMMENTS_DOWNLOADED,
    COMMENTS_PENDING,
    COMMENTS_FAILED,
    COMMENT_FAILED,
    COMMENT_POSTING,
    COMMENT_DELETED,
    COMMENT_DELETING
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: [],
    currentIndex: null,
    currentComment: null,
    pending: false,
    sending: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case COMMENT_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            newState.content = state.content.filter((comment)  => {
                return comment.id !== action.payload
            });

            if (state.currentComment) {
                if (state.currentComment.id === action.payload) {
                    newState.currentComment = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content.findIndex((comment) => {
                        return newState.currentComment.id === comment.id
                    });
                }
            }

            return newState;
        case COMMENTS_RESET:
            return INITIAL_STATE;
        case COMMENTS_PENDING:
            return {
                ...state,
                pending: true
            };
        case COMMENTS_DOWNLOADED:
            let newAppDownloadedState = {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
            };

            if (state.currentComment) {
                let newCurrentComment = state.content.find(function (comment) {
                    return comment.id === state.currentComment.id
                });
                if (newCurrentComment) {
                    newAppDownloadedState.currentComment = newCurrentComment;
                    newAppDownloadedState.currentIndex = newAppDownloadedState.content.findIndex((comment) => {
                        return newCurrentComment.id === comment.id
                    });
                }
            } else {
                newAppDownloadedState.currentComment = null;
                newAppDownloadedState.currentIndex = null;
            }

            return newAppDownloadedState;
        case COMMENTS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case COMMENT_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
                currentComment: null,
                currentIndex: 0
            };
        case COMMENT_POSTING:
            return {
                ...state,
                sending: true
            };
        case COMMENT_DELETING:
            return {
                ...state,
                sending: true
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/comments/reducers.js